import React from 'react';
import { Avatar } from '@mui/material';
import { useSelector } from 'react-redux';
import Badge from '@mui/material/Badge';
import defaultStore from '../../assets/images/defaultstoresidebar.svg';
import { lowerCase } from 'lodash';

function AvatarStore({ logo, showFlag = false }) {
  const { store } = useSelector(({ auth }) => auth);
  const profile = useSelector(({ auth }) => auth.store.profile ?? null);

  if (store?.logo) {
    <Avatar src={store.logo} alt="photoURL" />;
  }

  return (
    <Badge
      overlap="circular"
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      badgeContent={
        showFlag && (
          <img
            style={{
              width: '20px',
              maxHeight: '16px',
              marginRight: '16px',
              marginBottom: '2px',
              borderRadius: '2px',
              border: '1px solid #fff',
            }}
            src={`https://flagcdn.com/h20/${lowerCase(profile?.countryCode === 'UK' ? 'GB' : profile?.countryCode)}.png`}
          />
        )
      }
    >
      <Avatar className={!logo ? 'storeIcon' : 'storeLogo'} src={logo || defaultStore} alt="photoURL" />
    </Badge>
  );
}

export default AvatarStore;
